// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zzMaU","toggleWrap":"styles_toggleWrap__2DWQr","content":"styles_content__3M5Zd","selectAreaCode":"styles_selectAreaCode__3ThYm"};